/**
 * Created by Victor Rojo on 7/6/18.
 */
import { Component, TemplateRef, ViewChild, ElementRef, OnDestroy }          from '@angular/core';
import { Router, ActivatedRoute, Params }                   from '@angular/router';
import { FormGroup, FormControl,
  FormBuilder, Validators }   from '@angular/forms'
import { NotificationsService }     from 'angular2-notifications';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { Subject }            from 'rxjs';
import {debounceTime}         from 'rxjs/operators';
import {distinctUntilChanged} from 'rxjs/operators';

import { I18NService }        from "../shared/i18n/i18n.service";
import { Notification }       from "../model/notification";
import {NotificationService} from "./notification.service";
import {NotificationDetailComponent} from "./notification-detail.component";


@Component({
  templateUrl: './notification-list.component.html',
  styleUrls: [ './notification-list.component.css'],
})
export class NotificationListComponent implements OnDestroy{

  data: Notification[] = [];
  rows: any = [];
  private searchText= '';
  private searchTerms = new Subject<string>();
  isLoading = false;
  tableMessages: any;
  notificationPage: any;
  sort = 'launchDate,desc';
  sorts = [{prop: 'launchDate', dir: 'desc'}];
  statusFilterValues= [
    {real:null, display:"All"},
    {real:1, display:"Read"},
    {real:0, display:"Unread"}];
  activetStatusFilterValue: number = null;
  modalRef: BsModalRef;
  notification: any;
  search: string;
  @ViewChild('detailTemplate', { static: true })
  private detailTempRef : TemplateRef<any>;
  private filter: string;
  private subscription: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private notificationService: NotificationService,
    private i18nService: I18NService,
    private modalService: BsModalService,
    private displayNotificationService: NotificationsService) {

    this.notificationPage = {
      count: 0,
      pageSize: 15,
      offset: 0,
    };

    this.searchTerms
      .pipe(
        debounceTime(300),
        distinctUntilChanged()
      )
      .subscribe((result:string) => {
        this.searchText = result.toUpperCase();
        this.setNotificationPage(this.notificationPage);
      });

    this.route.params.subscribe((params: Params) => {
      if (params["filter"]) {
        this.searchText = params["filter"].toUpperCase();
        this.search = params["filter"];
      }
    });

    this.setNotificationPage(this.notificationPage);

    this.subscription = this.notificationService.newNotificationChange$.subscribe( (records:any[]) => {
      this.setNotificationPage(this.notificationPage);
    });

    this.tableMessages = {};
    this.tableMessages.emptyMessage = this.i18nService.get("noDataToDisplay");
    this.tableMessages.totalMessage = this.i18nService.get("total");
    this.tableMessages.selectedMessage = this.i18nService.get("selected");
  }

  onSearch(term: string){
    this.searchTerms.next(term);
  }

  setNotificationPage(pageInfo:any){
    this.isLoading = true;
    this.notificationPage.offset = pageInfo.offset;
    let filter = "";
    if ( this.activetStatusFilterValue != null ) {
      filter = "isReadFilter:=:" + ( this.activetStatusFilterValue ? "true" : "false") + ":B";
    }
    if ( this.searchText ) {
      let or =
      filter += filter ? ";|" : "";
      filter += this.searchText ? "iPlace.iPlaceName:ilike:" + this.searchText + ";|name:ilike:" + this.searchText : "";
    }

    this.notificationService.getPage(pageInfo.offset,pageInfo.pageSize,this.sort, filter)
      .then( response => {
        this.isLoading = false;
        let sort = response.sort ? response.sort[0].property + "," + response.sort[0].direction : "";
        this.notificationPage = {
          count: response.totalElements,
          pageSize: response.size,
          offset: response.number
        };
        this.rows = response.content;
        this.sorts = [{prop: response.sort[0].property, dir: response.sort[0].direction.toLowerCase()}];
      })
      .catch( error => {
        this.isLoading = false;
      });
  }

  onSort(event:any) {
    let prop = event.sorts[0].prop == "idiPlace" ? "iPlace.iPlaceName" : event.sorts[0].prop;
    this.sort = prop + "," + event.sorts[0].dir;
    this.setNotificationPage(this.notificationPage);
  }

  getNotificationLevelClass(notificationLevel: number){
    switch (notificationLevel) {
      case 1:
            return "row-info";
      case 2:
            return "row-warning";
      case 3:
            return "row-error";
      case 4:
            return "row-fatal";
    }
  }

  onActivate(event: any) {
    if ( event.type == 'click' && event.column.prop) {
      //this.router.navigate(['notifications/' + event.row.id]);
      this.notification = event.row;
      this.modalRef = this.modalService.show(NotificationDetailComponent);
      let promise = this.modalRef.content.loadNotification(event.row.id);
      promise.catch( (error:any) => {
          this.modalService.hide(1);
        });
    }
  }

  onClickStatusFilter(value: number): void{
    if ( value != this.activetStatusFilterValue ) {
      this.activetStatusFilterValue = value;
      this.setNotificationPage(this.notificationPage);
    }
  }

  public ngOnDestroy(): void {
    if ( this.subscription ) {
      this.subscription.unsubscribe();
    }
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }
}
